<template>
  <modal :show.sync="show" modalClasses="modal-hide-footer" size="lg">
    <h3 slot="header" class="mb-0">Ccris Supplementary</h3>
    <b-row>
      <b-col cols="12">
        <h4 style="margin-bottom: 10px">CCRIS SUPPLEMENTARY INFORMATION</h4>

            <!-- Address Information Section -->
        <div class="mb-4">
          <h5 style="margin-top: 20px; margin-bottom: 10px;">ADDRESS INFORMATION</h5>
          <div class="table-container">
            <table class="directories-table bordered summary-table" style="width: 100%">
              <thead>
                <tr>
                  <th style="width: 60px">No.</th>
                  <th>Address</th>
                  <th style="width: 120px">State</th>
                  <th style="width: 100px">Postcode</th>
                  <th style="width: 120px">Created Date</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(address, index) in addressInformation" :key="'address-' + index">
                  <td style="text-align: center">{{ address.no || (index + 1 + '.') }}</td>
                  <td>{{ safeDisplay(address.long_address || address.address) }}</td>
                  <td style="text-align: center">{{ safeDisplay(address.state) }}</td>
                  <td style="text-align: center">{{ safeDisplay(address.postcode) }}</td>
                  <td style="text-align: center">{{ formatDate(address.created_date) }}</td>
                </tr>
                <tr v-if="addressInformation.length === 0">
                  <td colspan="5" class="text-center">No Information Available</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        
        <!-- Contact Information Section -->
        <div class="mb-4">
          <h5 style="margin-top: 20px; margin-bottom: 10px;">CONTACT INFORMATION</h5>
          <div class="table-container">
            <table class="directories-table bordered summary-table" style="width: 100%">
              <thead>
                <tr>
                  <th style="width: 60px">No.</th>
                  <th>Contact Number</th>
                  <th style="width: 120px">Created Date</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(contact, index) in contactInformation" :key="'contact-' + index">
                  <td style="text-align: center">{{ contact.no || (index + 1 + '.') }}</td>
                  <td>{{ safeDisplay(contact.contact_number) }}</td>
                  <td style="text-align: center">{{ formatDate(contact.created_date) }}</td>
                </tr>
                <tr v-if="contactInformation.length === 0">
                  <td colspan="3" class="text-center">No Information Available</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>


        <!-- Occupation Information Section -->
        <div>
          <h5 style="margin-top: 20px; margin-bottom: 10px;">OCCUPATION INFORMATION</h5>
          <div class="table-container">
            <table class="directories-table bordered summary-table" style="width: 100%">
              <thead>
                <tr>
                  <th style="width: 60px">No.</th>
                  <th>Occupation</th>
                  <th>Employer</th>
                  <!-- <th style="width: 100px">Type</th> -->
                  <th style="width: 100px">From Date</th>
                  <th style="width: 100px">To Date</th>
                  <th style="width: 120px">Created Date</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(occupation, index) in occupationInformation" :key="'occupation-' + index">
                  <td style="text-align: center">{{ occupation.no || (index + 1 + '.') }}</td>
                  <td>{{ safeDisplay(occupation.occupation) }}</td>
                  <td>{{ safeDisplay(occupation.employer) }}</td>
                  <td style="text-align: center">{{ formatDate(occupation.from_date) }}</td>
                  <td style="text-align: center">{{ formatDate(occupation.to_date) }}</td>
                  <td style="text-align: center">{{ formatDate(occupation.created_date) }}</td>
                </tr>
                <tr v-if="occupationInformation.length === 0">
                  <td colspan="5" class="text-center">No Information Available</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </b-col>
    </b-row>
  </modal>
</template>

<script>
import Modal from "@/components/Modal";

export default {
  name: "CcrisSupplementaryModal",
  props: {
    ccrisSupplementary: {
      type: Object,
      default: () => ({
        address_information: [],
        contact_information: [],
        occupation_information: []
      }),
    },
    show_ccris_full_view: Boolean,
  },
  components: {
    Modal,
  },
  computed: {
    show: {
      get() {
        return this.show_ccris_full_view;
      },
      set(value) {
        this.$emit("update:show_ccris_full_view", value);
      },
    },
    // Extract contact information from ccrisSupplementary
    contactInformation() {
      return this.ccrisSupplementary?.contact_information || [];
    },
    // Extract address information from ccrisSupplementary
    addressInformation() {
      return this.ccrisSupplementary?.address_information || [];
    },
    // Extract occupation information from ccrisSupplementary
    occupationInformation() {
      return this.ccrisSupplementary?.occupation_information || [];
    }
  },
  methods: {
    formatDate(dateString) {
      if (!dateString) return '-';
      
      try {
        // Check if date is already in dd-mm-yyyy format (like "30-03-2010")
        if (typeof dateString === 'string' && dateString.includes('-')) {
          const parts = dateString.split('-');
          
          // If it's in dd-mm-yyyy format, return as is
          if (parts.length === 3 && parts[0].length === 2 && parts[1].length === 2 && parts[2].length === 4) {
            return dateString;
          }
          
          // If it's in yyyy-mm-dd format, convert to dd-mm-yyyy
          if (parts.length === 3 && parts[0].length === 4 && parts[1].length === 2 && parts[2].length === 2) {
            return `${parts[2]}-${parts[1]}-${parts[0]}`;
          }
        }
        
        // Try to parse as a Date object for other formats
        const date = new Date(dateString);
        if (!isNaN(date.getTime())) {
          return date.toLocaleDateString('en-GB', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric'
          }).replace(/\//g, '-');
        }
        
        // If all parsing fails, return the original string
        return dateString;
      } catch (e) {
        console.warn('Date parsing error for:', dateString, e);
        return dateString;
      }
    },
    
    // Safe display method to handle empty values
    safeDisplay(value) {
      if (value === null || value === undefined || value === '') {
        return '-';
      }
      
      // Handle empty arrays
      if (Array.isArray(value) && value.length === 0) {
        return '-';
      }
      
      // Handle arrays with content
      if (Array.isArray(value)) {
        return value.join(', ');
      }
      
      // Handle empty objects
      if (typeof value === 'object' && Object.keys(value).length === 0) {
        return '-';
      }
      
      // Handle string representations of empty arrays/objects
      if (typeof value === 'string' && (value === '[]' || value === '{}')) {
        return '-';
      }
      
      return value;
    }
  },

};
</script>

<style scoped>
/* Styles for the plain HTML tables matching DirectoriesBusinessModal style */
.directories-table {
  border-collapse: collapse;
  width: 100%;
  font-family: inherit;
}

.directories-table.bordered,
.directories-table th,
.directories-table td {
  border: 1px solid #000 !important;
}

/* Summary table specific header styling */
.summary-table th {
  background-color: #252938 !important;
  color: #fff !important;
  border: none !important;
  vertical-align: top !important;
  text-transform: none !important;
  font-size: 14px !important;
  font-weight: 400 !important;
  line-height: 19.5px !important;
  padding: 9px 12px !important;
}

/* Regular table header styling (for detailed tables) */
.directories-table:not(.summary-table) th {
  background-color: #a9a9a9 !important;
  background-image: none !important;
  color: #000 !important;
  font-weight: 700 !important;
  text-align: left;
  padding: 8px 6px;
}

.directories-table td {
  background-color: #fff !important;
  color: #000 !important;
  padding: 8px 6px;
  text-align: left;
}

.directories-table td:first-child {
  text-align: left;
}

.directories-table .text-break {
  white-space: normal;
}

/* Section header styling */
h4 {
  font-size: 18px;
  font-weight: 600;
  color: #333;
}

h5 {
  font-size: 16px;
  font-weight: 600;
  color: #555;
}

/* Table container for responsive design */
.table-container {
  width: 100%;
  overflow-x: auto;
}

/* Center text for specific cells */
.text-center {
  text-align: center !important;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .table-container {
    font-size: 0.7rem;
  }
  
  .directories-table th,
  .directories-table td {
    padding: 6px 4px;
  }
  
  h4 {
    font-size: 16px;
  }
  
  h5 {
    font-size: 14px;
  }
}

/* Margin adjustments */
.mb-4 {
  margin-bottom: 1.5rem;
}
</style>